"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle()
/*{globalVariables={}}={}*/
{
  return {
    Panel: {
      display: 'flex',
      flex: '1',
      '-ms-flex-preferred-size': 'auto',
      '& .panel.panel-default': {
        display: 'flex',
        flex: '1',
        '-ms-flex-preferred-size': 'auto',
        'flex-direction': 'column',
        'margin': '0',
        'box-shadow': '0px 1px 1px -1px #333',
        '& .panel-heading': {
          'font-weight': 600,
          'background-color': 'rgb(245, 245, 245)',
          'border-color': 'rgb(221, 221, 221)'
        },
        '& .panel-body': {
          padding: 0,
          flex: '1',
          '-ms-flex-preferred-size': 'auto',
          display: 'flex'
        }
      },
      '& .panelstate': {
        "float": 'right',
        '& .text': {
          paddingRight: '5px',
          fontWeight: '400'
        },
        '& .btn': {
          marginTop: '-5px',
          marginBottom: '-5px'
        }
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map